/* eslint-disable react/forbid-prop-types */
import { connect } from 'react-redux'
import { map } from 'lodash'

import { Component } from 'react'
import PropTypes from 'prop-types'
import { Col, Row } from 'react-bootstrap'
import classNames from 'classnames'

import SideNav from 'components/side-nav'
import * as blUrls from 'lib/urls'
import HelloBabyMeta from 'hello_baby/components/HelloBabyMeta/HelloBabyMeta'
import { displayBirthdayWishlistModal } from 'shared/BirthdayWishlistModal/BirthdayWishlistModal.utils'
import { track } from 'lib/analytics'
import { filterPostsByTopicSlug } from '../lib'
import PostCardRow from '../components/post-card-row'
import HeroPost from '../components/hero-post'
import TopicSection from '../components/topic-section'

import css from './landing-page.scss'

import { FEATURED_POSTS_COLLECTION_SLUG } from '../constants'

import { maybeFetchPosts } from '../actions'
import { SectionHeading } from '../../components/headings'

class LandingPage extends Component {
  componentDidMount() {
    // lazy load featured posts
    const { featuredPosts } = this.props

    maybeFetchPosts(map(featuredPosts, 'id'))
  }

  render() {
    const { featuredPosts, posts, topicNavigation, featureFlags, currentUser } =
      this.props

    if (currentUser && featureFlags.show_birthday_list_feature_modal) {
      displayBirthdayWishlistModal(
        { id: currentUser.registryId, ownerId: currentUser.id },
        track.EventLocation.LIST_ADOPTION_MODAL_MINUS_GUIDES
      )
    }

    const navCategory = { title: 'Home', path: '/hello-baby', urlSlug: null }
    const sideNavTree = []
    map(topicNavigation.items, (topic) => {
      const tempArray = []
      map(topic.children, (child) => {
        tempArray.push({
          title: child.name,
          urlSlug: child.slug,
          path: blUrls.helloBabyPostPath(child.slug),
        })
      })
      sideNavTree.push({
        title: topic.name,
        urlSlug: topic.slug,
        children: tempArray,
        path: blUrls.helloBabyPostPath(topic.slug),
      })
    })

    return (
      <>
        <HelloBabyMeta
          canonical={blUrls.babylistUrl(blUrls.helloBabyPath)}
          description="Find advice, tips, and product reviews to help you handle pregnancy and early parenting. Hello Baby makes parenting easier."
          keywords="baby product reviews, baby names, pregnancy tips, parenting advice, strollers, diapers, car seats, babies"
          title="Hello Baby by Babylist - Pregnancy and Parenting Advice"
        />
        <div className="container mtm pts ptn-sm mtxl-sm">
          <div className="visible-xs">
            <SectionHeading className="h3 mvm">Featured Guides</SectionHeading>
            <hr className="mtm mbl" />
          </div>
          <HeroPost post={featuredPosts[0]} />
          <PostCardRow
            featuredRow
            showTopics
            className="mtxl"
            colClassName="col-md-3"
            posts={featuredPosts.slice(1, 5)}
          />

          <Row className="mvl">
            <Col
              className={classNames(css.sideNavContainer, 'hidden-xs')}
              sm={3}
            >
              <SideNav
                categoryTree={sideNavTree !== 'undefined' ? sideNavTree : []}
                navCategory={navCategory}
                sidebarTitle="Guides"
              />
            </Col>
            <Col className="mtl" sm={9}>
              <div className={css.landingContainer}>
                {typeof topicNavigation.items !== 'undefined' &&
                  topicNavigation.items
                    .map((topic) => {
                      const topicPosts = filterPostsByTopicSlug(
                        posts,
                        topic.slug
                      ).slice(0, 5)
                      if (topicPosts && topicPosts.length) {
                        return (
                          <TopicSection
                            hideLastPostSm
                            key={`topic_section_${topic.slug}`}
                            posts={topicPosts}
                            showTopics={false}
                            topic={{ name: topic.name, slug: topic.slug }}
                          />
                        )
                      }

                      return null
                    })
                    .filter((topicSection) => topicSection)}
              </div>
            </Col>
          </Row>
        </div>
      </>
    )
  }
}

LandingPage.propTypes = {
  currentUser: PropTypes.object.isRequired,
  featureFlags: PropTypes.object.isRequired,
  featuredPosts: PropTypes.array.isRequired,
  posts: PropTypes.object.isRequired,
  topicNavigation: PropTypes.object.isRequired,
}

const mapStateToProps = (state) => ({
  featuredPosts: map(
    state.collections[FEATURED_POSTS_COLLECTION_SLUG].itemIds.slice(0, 5),
    (id) => state.posts[id]
  ), // take the first four posts
  posts: state.posts,
})

const ConnectedLandingPage = connect(mapStateToProps, {
  maybeFetchPosts,
})(LandingPage)

// eslint-disable-next-line import/no-default-export
export default ConnectedLandingPage
